export enum BreadcrumbStepType {
  Formio = "Formio",
  DocumentUpload = "DocumentUpload",
  ApplicationReview = "ApplicationReview",
  Contact = "Contact",
  TemplateDetails = "TemplateDetails",
}
